// src/components/Layout.jsx
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer"; 
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <>
      <style>{`
        .layout {
          display: flex;
          flex-direction: column;
          min-height: 100vh; /* full viewport height */
        }
        .content {
          flex: 1; /* take up remaining space */
        }
      `}</style>

      <div className="layout">
        <Navbar />
        <main className="content">
          <Outlet /> {/* Yaha child routes render honge */}
        </main>
        <Footer />
      </div>
    </>
  );
}

export default Layout;
